export const enumValues = <T extends object>(x: T): T[keyof T][] =>
  Object.values(x) as any
